import { render, staticRenderFns } from "./PackagingTypesTable.vue?vue&type=template&id=3b4aeccf&scoped=true"
import script from "./PackagingTypesTable.vue?vue&type=script&lang=js"
export * from "./PackagingTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4aeccf",
  null
  
)

export default component.exports